export default __webpack_public_path__ + "static/topmenu04@2x-47c7f6c5ee56389ca43ef38bfba4e617.png";